import React from 'react';
import styled from 'styled-components';
import { useTheme } from '@material-ui/core/styles';
import requiredButton from './img/Danger.png';

interface LabelProps {
  text: string;
  required?: boolean;
  info?: boolean;
  conditional?: boolean;
  isPageEditor?: boolean;
}
export const Label: React.FC<LabelProps> = ({ text, required, isPageEditor }) => {
  const theme = useTheme();
  return (
    <LabelHolder theme={theme}>
      <LabelText isPageEditor={isPageEditor} theme={theme}>
        {text}
      </LabelText>
      {required && (
        <BadgeHolder theme={theme}>
          <img src={requiredButton} alt="required" />
        </BadgeHolder>
      )}
    </LabelHolder>
  );
};

export const StandardInputFrame = styled.div`
  position: relative;
  padding-top: 14px;
  padding-bottom: 15px;
`;
export const LabelText = styled.div<{ isPageEditor?: boolean; theme?: any }>`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  text-align: left;
  margin-left: ${(props) => (props.isPageEditor ? '0px' : '15px')};
  color: ${({ theme }) => theme?.palette?.text?.primary || 'red'};
`;
export const LabelHolder = styled.div<{ theme?: any }>`
  display: flex;
  margin-bottom: 2px;
`;
export const BadgeHolder = styled.div<{ theme?: any }>`
  margin-right: 8px;
  margin-top: -2px;
`;
export const LabelSubText = styled.div<{
  isGroup?: boolean;
  isDisplayOptionsEnabled?: boolean;
  isList?: boolean;
  theme?: any;
}>`
  font-size: 15px;
  font-weight: 400;
  margin-top: ${(props) => (props.isDisplayOptionsEnabled && props.isGroup ? '-5px' : '8px')};
  color: ${({ theme }) => theme?.palette?.text?.secondary || '#666'};
  margin-bottom: ${(props) => (props.isList ? '9px' : '0')};
`;
export const ShrinkInfo = styled.span<{ theme?: any }>`
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  color: ${({ theme }) => theme?.palette?.text?.secondary || '#666'};
  margin-top: 8px;
`;
